import { BanIcon, CheckCircleIcon, ChevronDownIcon } from '@heroicons/react/outline'
import { Checkbox, Modal, Spinner } from 'flowbite-react'
import React, { Fragment, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useMutation, useQuery } from 'react-query'
import { toast } from 'react-toastify'
import boissonService from '../services/boisson.service'
import Constants from '../tools/constants.tools'
import {InputUi, SelectUi, TextAreaUi} from '../components/input.ui'
import {ButtonUi} from '../components/components'
import { ImageUi } from '../components/image.ui'
import { Menu, Transition } from '@headlessui/react'
import tokenMiddleware from '../middleware/token.middleware'


function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export const Boisson = () =>{

  const dropdownList = [
    { name: 'Modifier', href: '#', index: 1 },
    { name: 'Supprimer', href: '#', index: 2 },
  ]


  const _image = [
    {
      id: 0,
      img: null,
      cloud: null,
      error: null,
      name:'image'
    },
  ]

  const [state, setState] = useState({
    showModal: false,
    error: null,
    type:'new',
    image: _image,
    selectedBoisson:null,
    confirmDelete:false
  })

  const initState = () => setState({ 
    ...state, confirmDelete:false, showModal:false, 
    selectedBoisson:null, type:'new' 
  })

  const _boissons = useQuery('boissons', boissonService.getAll, {})
  const _form = useForm({mode: 'all'});

  const _boissonAdd = useMutation(boissonService.create, {
    onSuccess: resp => {
      _boissons.refetch()
      _form.reset()
      toast.success('Boisson ajoutée avec succès')
    },
    onError: resp => {
        if(resp?.response?.data?.error){
          toast.error(resp?.response?.data?.error)
        } else
        toast.error("Une erreur inconnue s'est produite")
      },
      onSettled: () => initState()
  })


  const _switchStatus = useMutation(boissonService.switchStatus, {
    onSuccess: resp => {
      _boissons.refetch()
    },
    onError: resp => {
        if(resp?.response?.data?.error){
          toast.error(resp?.response?.data?.error)
        } else
        toast.error("Une erreur inconnue s'est produite")
      },
      onSettled: () => initState()
  })

  const _boissonUpdate = useMutation(boissonService.update, {
    onSuccess: resp => {
        _boissons.refetch()
        _form.reset()
        _boissonUpdate.reset()
        toast.success('Boisson modifiée avec succès')
      },
      onError: resp => {
        if(resp?.response?.data?.error){
          toast.error(resp?.response?.data?.error)
        } else
        toast.error("Une erreur inconnue s'est produite")
      },
      onSettled: () => initState()
  })
  

  const _boissonDelete = useMutation(boissonService.delete, {
    onSuccess: resp => {
      _boissons.refetch()
      toast.success('Boisson supprimée avec succès')
    },
    onError: resp => {
      if(resp?.response?.data?.error){
        toast.error(resp?.response?.data?.error)
      } else
      toast.error("Une erreur inconnue s'est produite")
    },
    onSettled: () => initState()
  })

  const updateBoisson = (item) => {
    let updateImage = _image;
    updateImage = updateImage.map(p => {
      if(item.image !== null)
        return {
          ...p,
          img:Constants.IMAGE_LINK + item.image,
          cloud: Constants.IMAGE_LINK + item.image
        }
      return p
    })
    _form.setValue('prix', item.prix)
    _form.setValue('name', item.nom)
    _form.setValue('typeBoison', item.typeBoison)
    setState({
      ...state,
      showModal: !state.showModal, 
      type:'edit', confirmDelete:false,
      selectedBoisson: item,
      image: updateImage
    })
  }

  const convert2base64 = (file, name) => {
    if (file && file.type.substr(0, 5) === 'image') {
      const reader = new FileReader();
      reader.onloadend = () => {
        if(reader.result.length <= Constants.imageSize){
          setState({
            ...state,
            error: null,
            type: 'new',
            image: state.image.map(e => {
              if (e.name === name)
                return {
                  ...e,
                  img: reader.result.toString(),
                  cloud: file
                }
              return e
            }),
          })
        } else {
          setState({
            ...state,
            type: 'upload',
            error: "Taille de l'image ne doit pas dépasser 5M"
          })
        }
      }
      reader.readAsDataURL(file)
    } else {
      setState({
        ...state,
        image: state.image.map(e => {
          if (e.name === name)
            return { ...e}
          return e
        }),
      })
      toast.error('error image')
    }
  }
  
  const onSubmit = (r) => {
    setState({ ...state, error: null })
    if (state.image[0].img) {
      let formData = new FormData();
      formData.append('nom', r.name)
      formData.append('typeBoisson', r.typeBoisson)
      formData.append('prix', parseInt(r.prix))
      formData.append('image', state.image[0].cloud)
      formData.append('id', state.selectedBoisson?._id)


      if(state.type === 'new')
        _boissonAdd.mutate(formData)
      if(state.type === 'edit')
        _boissonUpdate.mutate(formData)

    } else {
      toast.error('Veillez ajouter l\'image de la boisson')
    }
  }

  var typeBoison = [
    "JUS",
    "EAU"
  ]

  return (
    <div className="bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
      <div className="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap pb-5">
        <div className="ml-4 mt-4">
          <h3 className="text-lg leading-6 font-medium text-gray-900">Les boissons</h3>
          <p className="mt-1 text-sm text-gray-500">
            La liste des boissons 
          </p>
        </div>
        <div className="ml-4 mt-4 flex-shrink-0">
          <button
            type="button"
            className="relative inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-primary focus:outline-none focus:ring-2 focus:ring-offset-2"
            onClick={() => {
              setState({
                ...state,
                showModal: true,
                error: null,
                image: _image,
                selectedBoisson:null,
                type:'new'
              })
              _form.reset()
              _boissonAdd.reset()
            }
          }
          >
            Ajouter une nouvelle boisson
          </button>
        </div>

        <React.Fragment>
            <Modal
              show={state.showModal}
              size='md'
              onClose={() => initState()}>
              <Modal.Header>{state.type === 'new' ? 'Nouvelle boisson' : 'Description'}</Modal.Header>
              <Modal.Body className="space-y-6">
                <div>
                  <label htmlFor='image' className="text-gray-700 font-medium text-xs">
                    Image de la boisson
                  </label>
                  
                  <div className="flex items-center justify-center gap-2 pb-2">
                    {state.image?.map(item => (
                      <ImageUi
                        key={item.id} error={item.error}
                        img={item.img} name={item.name}
                        cloud={item.cloud}
                        onChange={(e) => convert2base64(e.target.files[0], item.name)}
                      />
                    ))}
                  </div>
                    {
                      state.type === 'upload' && state.error !== null &&
                      <p className='text-red-500 text-sm'>{state.error}</p>
                    }
                  <form onSubmit={_form.handleSubmit(onSubmit)}>
                      <InputUi
                        label='Prix'
                        name='prix'
                        type='number'
                        placeholder='Prix de la boisson'
                        register={_form.register}
                        error={_form.formState.errors?.prix?.message}
                        validations={{
                          required: 'Le prix est obligatoire',
                          pattern:{
                            value:  RegExp("^[0-9]+$"),
                            message: 'error type value'
                          }
                        }}
                      />

                    <InputUi
                      label='Boisson'
                      name='name'
                      type='text'
                      placeholder='Nom de la boisson'
                      register={_form.register}
                      error={_form.formState.errors?.name?.message}
                      validations={{
                        required: 'Le nom est obligatoire'
                      }}
                    />

                    <SelectUi
                        label="Type de boisson"
                        name="typeBoisson"
                        register={_form.register}
                        validations={{ required: 'Selectionner un type' }}
                        error={_form.formState.errors?.typeBoisson?.message}
                      >
                      {
                        typeBoison?.map((e, index) => {
                          return (
                            <option key={index} value={e.toLowerCase()}>{e}</option>
                          )
                        }
                        )
                      }
                    </SelectUi>
                    <div>
                      <ButtonUi isLoading={_boissonAdd.isLoading || _boissonUpdate.isLoading}>
                        { state.type === 'new' ? 'Enregistrer' : 'Modifier'}
                      </ButtonUi>
                    </div>
                  </form>
                </div>
              </Modal.Body>
            </Modal>
          </React.Fragment>
      </div>
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-gray-300" />
        </div>
      </div>

      {/* dropdown list  */}
      
    
      <div className="pt-5 flex flex-wrap">
        {_boissons.isLoading && LoadingUI()}
        {
          _boissons.isSuccess && _boissons.data?.data['jus'].length !== 0 
              && _boissons.data?.data['jus'].map(item => (
                <div key={item._id} className='bg-white shadow-xl p-3 ml-5 mb-5 rounded-xl'>
                  
                  <div className="flex justify-end pr-2 pb-1">
                    {
                      state.confirmDelete && item._id === state.selectedBoisson?._id && state.type === 'delete'
                      && <Spinner
                          aria-label="Small spinner example"
                          size="sm"
                        />
                    }

                    {
                      state.confirmDelete && item._id === state.selectedBoisson?._id && state.type === 'delete'
                      ? <div/>
                      : <Menu as="div" className="ml-2 relative">
                          <div>
                            <Menu.Button className="">
                            <ChevronDownIcon className='h-5 w-5 bg-gray-200 cursor-pointer p-1 rounded-full'/>
                            </Menu.Button>
                          </div>
                          <Transition
                              as={Fragment}
                              enter="transition ease-out duration-100"
                              enterFrom="transform opacity-0 scale-95"
                              enterTo="transform opacity-100 scale-100"
                              leave="transition ease-in duration-75"
                              leaveFrom="transform opacity-100 scale-100"
                              leaveTo="transform opacity-0 scale-95">
                              <Menu.Items className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                                {dropdownList.map((el) => (
                                  <Menu.Item key={el.name}>
                                    {({ active }) => (
                                      <a
                                        href={el.href}
                                        onClick={() => {
                                          if(el.index === 1){
                                            updateBoisson(item)
                                          }else{
                                            setState({ ...state, confirmDelete:true, type:'delete', selectedBoisson:item })
                                            _boissonDelete.mutate(item._id)
                                          }
                                        }}
                                        className={classNames(
                                          active ? 'bg-gray-100' : '',
                                          'block px-4 py-2 text-sm text-gray-700'
                                        )}
                                      >
                                        {el.name}
                                      </a>
                                    )}
                                  </Menu.Item>
                                ))}
                              </Menu.Items>
                          </Transition>
                        </Menu>
                    }
                  </div>
                  <img src={Constants.IMAGE_LINK+item.image} alt="" className=' h-32 w-32 rounded-md'/>
                  <p className="mt-1 text-gray-500">{item.nom}</p>
                  <div className='p-1 bg-indigo-600 rounded-full'>
                    <p className="ml-2 text-sm text-white">{item.prix} GNF</p>
                  </div>
                </div>
              ))
        }
        {
          _boissons.isSuccess && _boissons.data?.data['eaux'].length !== 0 
              && _boissons.data?.data['eaux'].map(item => (
                <div key={item._id} className='bg-white shadow-xl p-3 ml-5 mb-5 rounded-xl'>
                  
                  <div className="flex justify-end pr-2 pb-1">
                    {
                      state.confirmDelete && item._id === state.selectedBoisson?._id && state.type === 'delete'
                      && <Spinner
                          aria-label="Small spinner example"
                          size="sm"
                        />
                    }

                    {
                      state.confirmDelete && item._id === state.selectedBoisson?._id && state.type === 'delete'
                      ? <div/>
                      : <Menu as="div" className="ml-2 relative">
                          <div>
                            <Menu.Button className="">
                            <ChevronDownIcon className='h-5 w-5 bg-gray-200 cursor-pointer p-1 rounded-full'/>
                            </Menu.Button>
                          </div>
                          <Transition
                              as={Fragment}
                              enter="transition ease-out duration-100"
                              enterFrom="transform opacity-0 scale-95"
                              enterTo="transform opacity-100 scale-100"
                              leave="transition ease-in duration-75"
                              leaveFrom="transform opacity-100 scale-100"
                              leaveTo="transform opacity-0 scale-95">
                              <Menu.Items className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                                {dropdownList.map((el) => (
                                  <Menu.Item key={el.name}>
                                    {({ active }) => (
                                      <a
                                        href={el.href}
                                        onClick={() => {
                                          if(el.index === 1){
                                            updateBoisson(item)
                                          }else{
                                            setState({ ...state, confirmDelete:true, type:'delete', selectedBoisson:item })
                                            _boissonDelete.mutate(item._id)
                                          }
                                        }}
                                        className={classNames(
                                          active ? 'bg-gray-100' : '',
                                          'block px-4 py-2 text-sm text-gray-700'
                                        )}
                                      >
                                        {el.name}
                                      </a>
                                    )}
                                  </Menu.Item>
                                ))}
                              </Menu.Items>
                          </Transition>
                        </Menu>
                    }
                  </div>
                  <img src={Constants.IMAGE_LINK+item.image} alt="" className=' h-32 w-32 rounded-md'/>
                  <p className="mt-1 text-gray-500">{item.nom}</p>
                  <div className='p-1 bg-indigo-600 rounded-full'>
                    <p className="ml-2 text-sm text-white">{item.prix} GNF</p>
                  </div>
                </div>
              ))
        }

        {
          _boissons.isSuccess && _boissons.data?.data['jus'].length === 0 &&
          _boissons.isSuccess && _boissons.data?.data['eaux'].length === 0 &&
          <p className='text-gray-600 text-sm'>Aucune boisson ajoutée {<br/>}cliquez sur "Ajouter une boisson"</p>
        }
      </div>
    </div>
  )
}


const LoadingUI = () => {
  return (
    <div>
      <h1 className='text-gray-600 text-sm'>Chargement...</h1>
    </div>
  )
}

